
import axios from 'axios';
import { getServerError } from '../error/error-service';
import { IApiPage } from '../paging/paging-service.types';
import { IApiChangeHistoryEvent, IApiGetEventListParams, IApiColumnInfo, IApiGetColumnListParams } from './event-service.types';

const EventApiBaseUrl = `/event-api/api`;

export const getEventList = (params: Partial<IApiGetEventListParams>) => {
    return axios.get<IApiPage<IApiChangeHistoryEvent>>(`${EventApiBaseUrl}/event`, { params: params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}


export const getColumnList = (params: Partial<IApiGetColumnListParams>) => {
    return axios.get<IApiColumnInfo[]>(`${EventApiBaseUrl}/info/column`, { params: params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}